import qoalaStorage from '~/core/Storage';

export default () => ({
  lifeInsuranceData: JSON.parse(qoalaStorage.getItem('lifeInsuranceData') || '{}'),
  listProduct: JSON.parse(qoalaStorage.getItem('lifeInsuranceProduct')),
  productDetail: JSON.parse(qoalaStorage.getItem('productDetailLife'))
});
